import { Checklist, DomainEntityType } from '@models';
import { EntityMetadata } from '@ngrx/data';

export const checklistMetadata: EntityMetadata<Checklist> = {
  entityName: DomainEntityType.Checklist,
  selectId: (checklist: Checklist) => checklist.id,
};
